import { CompTextFieldCore } from '../core/forms/text-field/comp'

export const CompTextField = CompTextFieldCore
